const fieldValidation = {
  required: '{{fieldName}} 是必须的',
  pattern: '{{fieldName}} 无效',
  min: '{{fieldName}} 不得小于 {{value}}',
  max: '{{fieldName}} 不得大于 {{value}}',
};

export default fieldValidation;
